let highlightTextSplits = [];

export async function initializeHighlightText() {
    const headings = document.querySelectorAll("[data-highlight-text]");

    if (!headings.length) return;

    // Wacht tot het juiste font geladen is
    if (document.fonts?.ready) {
        await document.fonts.ready;
    }

    headings.forEach((heading) => {
        if (heading.dataset.highlightInitialized === "true") {
            return;
        }

        heading.dataset.highlightInitialized = "true";

        const scrollStart =
            heading.dataset.highlightScrollStart || "top 90%";

        const scrollEnd =
            heading.dataset.highlightScrollEnd || "bottom 40%";

        const fadedValue = Number(
            heading.dataset.highlightFade ?? 0.2
        );

        const staggerAmount = Number(
            heading.dataset.highlightStagger ?? 1
        );

        const split = SplitText.create(heading, {
            type: "words,chars",
            wordsClass: "highlight-word",
            charsClass: "highlight-char"
        });

        // Zorg dat álle letters vooraf dezelfde beginwaarde hebben
        gsap.set(split.chars, {
            opacity: fadedValue
        });

        gsap.to(split.chars, {
            opacity: 1,
            ease: "none",
            stagger: {
                amount: staggerAmount,
                from: "start"
            },
            scrollTrigger: {
                trigger: heading,
                start: scrollStart,
                end: scrollEnd,
                scrub: true,
                invalidateOnRefresh: true
            }
        });

        highlightTextSplits.push(split);
    });

    requestAnimationFrame(() => {
        ScrollTrigger.refresh();
    });
}

export function introUsps() {

    gsap.from(".introduction__usp", {
        opacity: 0,
        y: 30,
        filter: "blur(6px)",
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.12,
        scrollTrigger: {
            trigger: ".introduction__usps",
            start: "top 80%",
            toggleActions: "play none none reverse"
        }
    });
}